import PropTypes from "prop-types";

import { MONOLITH_ORIGIN } from "@/monolithIntegration/monolithIntegration.constants";
import getAssignmentActivities from "./getAssignmentActivities";
import StepItem from "./StepItem";

const propTypes = {
  /**
   * Array of assigment steps to sort.
   */
  assignmentMembers: PropTypes.arrayOf(PropTypes.object),
  /**
   * Function to fire when assignment step is deleted.
   */
  handleDeleteStep: PropTypes.func,
  /**
   * Function to fire when assignment is moved.
   */
  handleMoveStep: PropTypes.func,
};

const ListOfSteps = (props) => {
  const { assignmentMembers, handleDeleteStep, handleMoveStep } = props;

  /**
   * Get the correct url path prefix for read pages based on the content type.
   *
   * For example:
   * (articleheader) becomes 'read'
   * (audiotrack) becomes 'audio-tracks'
   *
   * @param {String} - contentType
   */
  const getViewUrlType = (contentType) => {
    const typeMap = {
      video: "videos",
      articleheader: "read",
      audiotrack: "audio-tracks",
    };
    return typeMap[contentType];
  };

  return (
    <>
      {assignmentMembers?.map((assignment, index) => {
        return (
          <StepItem
            assignmentActivities={getAssignmentActivities(assignment)}
            contentViewUrl={`${MONOLITH_ORIGIN}/${getViewUrlType(assignment.content_type)}/${assignment.slug}`}
            index={index}
            id={assignment?.content_id}
            key={assignment?.content_id}
            assignment={assignment}
            handleDeleteStep={handleDeleteStep}
            handleMoveStep={handleMoveStep}
            stepsSize={assignmentMembers.length}
          />
        );
      })}
    </>
  );
};

ListOfSteps.propTypes = propTypes;
export default ListOfSteps;
